import TokenService from '@/helpers/token';
import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';

// routers
import { authRouters } from '../modules/auth/router/auth.router';
import { HomePageRouters } from '../modules/home-page/router/home.router';
import { faqRoute } from '@/modules/faq/router/faq.router';
import { collaboratorsRoute } from '@/modules/collaborators/router/collaborators.router';
import store from '@/store';
import { kycStatus } from '@/helpers/constants';
import { isEmptyArray } from 'vee-validate/dist/types/utils';
import { errorRouters } from '@/modules/common/router';

// DataDog RUM

Vue.use(VueRouter);
const routes: Array<RouteConfig> = [
    ...authRouters,
    ...HomePageRouters,
    ...faqRoute,
    // ...collaboratorsRoute,
    ...errorRouters
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior: (to) => {
        if (to.hash) {
            return { selector: to.hash };
        }
        return { x: 0, y: 0 };
    },
});

router.beforeEach(async (to, from, next) => {
    const whiteList = [
        '/login',
        '/register',
        '/otp',
        '/user/reset-password',
        '/404',
        '/500',
        '/forgot-password',
        '/',
    ];
    const isRequiresAuth = to?.meta?.requiresAuth || false;
    const loggedIn = TokenService.getToken();
    if (loggedIn) {
        const { data, status_code } = await store.dispatch('auth/getMe');
       if(status_code === 200) {
           if (
               to.path === '/login' ||
               to.path === '/register' ||
               to.path === '/otp' ||
               to.path === '/user/reset-password' ||
               to.path === '/forgot-password' ||
               (data.kyc_status === kycStatus.PENDING && to.path === '/verification') ||
               (data.kyc_status === kycStatus.APPROVED && to.path === '/verification')
           ) {
               next({ path: '/' });
           }
       }else {
           TokenService.removeToken()
       }
    } else {
        if (whiteList.indexOf(to.path) !== -1) {
            if (to.path === '/user/reset-password') {
                if (JSON.stringify(to.query) === '{}') {
                    next('/login');
                } else {
                    next();
                }
            }
            next();
        } else {
            if (
                to.path === '/verification' ||
                to.path === '/change-password' ||
                // to.path === '/invite-register' ||
                to.path === '/history' ||
                to.path === '/collection'
            ) {
                next({ path: '/login' });
            }
        }
    }
    return next();
});

export default router;
